<template>
  <div class="top5-countries">
    <div class="title">
      Top Performing Countries by
    </div>
    <div class="options" :style="{ 'flex-direction': !isDesktop && 'column' }">
      <a-select
        v-model:value="query.operType"
        :style="{ 'margin-bottom': !isDesktop && '10px', width: '170px' }"
        @change="getData"
      >
        <a-select-option
          v-for="item in chartOptions"
          :key="item.value"
          :value="item.value"
        >
          {{ item.label }}
        </a-select-option>
      </a-select>
      <LastXDays v-model:value="query.time" @get-data="getData"></LastXDays>
    </div>
    <a-spin :spinning="spinning"
      ><div ref="countryChart" id="countryChart"></div
    ></a-spin>
  </div>
</template>

<script>
import LastXDays from '@/components/LastXDays'
import { fetchGetTop5Countries } from '@/api/account'
import echarts from 'echarts'

const chartTheme = require('@/styles/chart_theme/macarons.json')
let chart = undefined

const chartOptions = [
  {
    label: 'New Registrations',
    value: 2,
    key: 'newRegistrations',
  },
  {
    label: 'New Deposit Clients',
    value: 6,
    key: 'newDespositClients',
  },
  {
    label: 'New Real Traders',
    value: 3,
    key: 'newRealTraders',
  },
]

const fakeCountries = [
  'Country A',
  'Country B',
  'Country C',
  'Country D',
  'Country E',
]

export default {
  name: 'Top5Countries',
  components: { LastXDays },
  created() {
    this.getData()
  },
  data() {
    return {
      query: {
        time: 7,
        operType: 2,
      },
      chartOptions,
      chartData: undefined,
      chart: undefined,
      spinning: false,
    }
  },
  computed: {
    isDesktop() {
      return this.$store.state.app.device === 'desktop'
    },
  },
  methods: {
    getData() {
      this.spinning = !this.spinning
      fetchGetTop5Countries(this.query)
        .then((res) => {
          this.chartData = res
          this.initChart()
        })
        .finally(() => {
          this.spinning = !this.spinning
        })
    },
    initChart() {
      echarts.registerTheme('macarons', chartTheme)
      chart = echarts.init(this.$refs.countryChart, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(data) {
      let xData = []
      let yData = []
      const valueName = chartOptions.find(
        (item) => this.query.operType === item.value,
      ).key
      if (data.length) {
        data.forEach((item) => {
          yData.push(item.country)
          xData.push(item[valueName])
        })
      } else {
        yData.push(...fakeCountries)
        xData.push(...new Array(5).fill(0))
      }
      chart.setOption(
        {
          tooltip: {},
          grid: {
            left: 100,
          },
          xAxis: {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
          },
          yAxis: {
            type: 'category',
            data: yData.reverse(),
            axisLine: {
              show: false,
            },
            axisLabel: {
              formatter: function(v) {
                return v.length > 15 ? v.substr(0, 12) + '...' : v
              },
            },
          },
          series: [
            {
              name: '',
              type: 'bar',
              barMinHeight: 4,
              data: xData.reverse(),
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'right', //在上方显示
                  },
                },
              },
            },
          ],
        },
        true,
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.top5-countries {
  padding: 20px;
  // width: 490px;
  height: 370px;
  background-color: #fff;
  text-align: left;
  border-radius: 4px;

  .title {
    font-size: 20px;
  }

  .options {
    margin-top: 15px;
    display: flex;
    justify-content: space-between;
  }

  #countryChart {
    width: 100%;
    height: 250px;
    margin: auto auto;
  }
}
</style>
